import { render, staticRenderFns } from "./ExamFreedomAnalysis.vue?vue&type=template&id=cb5538d8&"
import script from "./ExamFreedomAnalysis.vue?vue&type=script&lang=js&"
export * from "./ExamFreedomAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports